import { render } from "./SectionCareer.vue?vue&type=template&id=3c9fd9b2&scoped=true"
import script from "./SectionCareer.vue?vue&type=script&lang=js"
export * from "./SectionCareer.vue?vue&type=script&lang=js"

import "./SectionCareer.vue?vue&type=style&index=0&id=3c9fd9b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9fd9b2"]])

export default __exports__